<p-menubar styleClass="slm-topbar">
  <ng-template pTemplate="start">
    <div class="slm-topbar__left">
      <app-logo />
    </div>
  </ng-template>

  <ng-template pTemplate="end">
    @if (publicLegal()) {
    <div class="slm-topbar__right">
      <button type="button" class="slm-login-pill" (click)="goToLogin()">Log in</button>
    </div>
    } @else {
    <div class="slm-topbar__right">
      @if (showFeedbackWidget && feedbackPortalId) {
      <div [attr.data-pp-cfiw-widget]="feedbackPortalId" data-env="prod" data-static="false"></div>
      } @if (showCustomerDocs) {
      <app-customer-docs-launcher />
      }

      <app-notification-bell />

      <div class="slm-profile-wrap" #profileWrap>
        <p-menu
          #profileMenu
          [model]="profileMenuItems"
          [popup]="true"
          [appendTo]="profileWrap"
          styleClass="slm-profile-menu"
          (onShow)="profileMenuOpen = true"
          (onHide)="profileMenuOpen = false"
        ></p-menu>

        <button
          #menuButton
          type="button"
          class="slm-profile-btn"
          [class.is-open]="profileMenuOpen"
          (click)="profileMenu.toggle($event)"
          [pTooltip]="showNameTooltip ? tooltipText : undefined"
          [tooltipStyleClass]="'slm-tooltip'"
          [appendTo]="'body'"
          tooltipPosition="bottom"
          aria-haspopup="menu"
          [attr.aria-expanded]="profileMenuOpen"
        >
          @if (displayName | titlecase; as name) {
          <div class="slm-avatar">
            <span class="slm-avatar__text">
              {{ (name.split(' ')[0]?.[0] || '') + (name.split(' ')[1]?.[0] || '') }}
            </span>
          </div>
          }

          <div class="slm-profile-text">
            <div class="slm-profile-name">{{ displayName | titlecase }}</div>
            <div class="slm-profile-role">{{ role | titlecase }}</div>
          </div>

          <i class="pi pi-chevron-down slm-chevron" aria-hidden="true"></i>
        </button>
      </div>
    </div>
    }
  </ng-template>
</p-menubar>
